module.exports = __webpack_public_path__ + "static/preferences-demo-6a9b4814ccf0e037d7887b06c6b44143.webm";